import React, {memo} from 'react';
import {Form} from '@themesberg/react-bootstrap';
import Countries from './Countries';

const FieldRow = memo((props) => {
  let {intl, handleChange, validDiscount, discountFailMessage, formData, bookingInfos, handleApplyDiscount, id, name1, name2, required1, required2} = props;
  let isDefaultField;
  let type = 'text';
  let variable1 = convertDefaultFieldNameToVariableName(name1);
  let variable2 = convertDefaultFieldNameToVariableName(name2);

  switch (name1) {
    case 'FIRST_NAME':
    case 'LAST_NAME':
    case 'COMPANY_NAME':
    case 'STREET_ADDRESS':
    case 'APARTMENT_OFFICE_ETC':
    case 'CITY':
    case 'ORDER_NOTES':
    case 'FLIGHT_OR_TRAIN_NUMBER':
      isDefaultField = true;
      type = 'text';
      break;
    case 'EMAIL_ADDRESS':
      isDefaultField = true;
      type = 'email';
      break;
    case 'PHONE':
      isDefaultField = true;
      type = 'tel';
      break;
    case 'ZIP_CODE':
      isDefaultField = true;
      type = 'number';
      break;
    case 'COUNTRY':
    case 'BOOKING_DISCOUNT_CODE':
      isDefaultField = true;
      break;
  }

  // Clé technique renvoyée au checkout : variable du champ natif, ou « {id}-1 » / « {id}-2 » pour un champ
  // personnalisé (colonne du champ). Jamais le libellé : il est traduit selon la langue de la page.
  const key1 = generateId(isDefaultField, id, variable1, 1);
  const key2 = generateId(isDefaultField, id, variable2, 2);

  if (name1 === 'COUNTRY') {
    return <div className="ccv2-field-row">
      <div className="ccv2-field ccv2-field--country">
        <label className="ccv2-field-label" htmlFor="country">{intl.formatMessage({id: 'COUNTRY'})}</label>
        <Countries id="country" onChange={handleChange} value={formData.country} intl={intl}/>
      </div>
    </div>
  } else if (name1 === 'ORDER_NOTES') {
    return <div className="ccv2-field-row">
      <div className="ccv2-field ccv2-field--notes">
        <label className="ccv2-field-label" htmlFor="notes">
          {intl.formatMessage({id: 'ORDER_NOTES'})} <span className="ccv2-field-optional">({intl.formatMessage({id: 'OPTIONAL'})})</span>
        </label>
        <Form.Control as="textarea" rows="3" id="notes" placeholder={intl.formatMessage({id: 'PLACEHOLDER_ORDER_NOTES'})} maxLength="1000"
                      onChange={handleChange} value={formData.notes || ''}/>
      </div>
    </div>
  } else if (name1 === 'BOOKING_DISCOUNT_CODE') {
    if (!bookingInfos.discount) {
      return <></>
    }
    return <div className="ccv2-field-row">
      <div className="ccv2-field ccv2-field--discount">
        <label className="ccv2-field-label" htmlFor="discountCode">{intl.formatMessage({id: 'BOOKING_DISCOUNT_CODE'})}</label>
        <div className="ccv2-discount">
          <Form.Control
            {...(validDiscount !== undefined && validDiscount ? {disabled: true} : {})}
            {...(validDiscount !== undefined && validDiscount ? {isValid: true} : {})}
            {...(validDiscount !== undefined && !validDiscount ? {isInvalid: true} : {})}
            className="ccv2-discount-input"
            type="text"
            id="discountCode"
            maxLength="32"
            onChange={handleChange}
            onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); handleApplyDiscount(); } }}
            value={formData.discountCode || ''}
          />
          <button type="button" className="ccv2-btn ccv2-btn-secondary ccv2-discount-btn"
                  disabled={validDiscount === true} onClick={handleApplyDiscount}>
            {intl.formatMessage({id: 'APPLY'})}
          </button>
        </div>
        {validDiscount === true &&
          <div className="ccv2-discount-feedback is-valid">{intl.formatMessage({id: 'DISCOUNT_CODE_OK'})}</div>}
        {validDiscount === false &&
          <div className="ccv2-discount-feedback is-invalid">{discountFailMessage || intl.formatMessage({id: 'DISCOUNT_CODE_FAIL'})}</div>}
      </div>
    </div>
  }

  if (isDefaultField) {
    name1 = intl.formatMessage({id: name1});
    if (name2) {
      name2 = intl.formatMessage({id: name2});
    }
  }

  return <div className={`ccv2-field-row ${name2 ? 'is-pair' : ''}`}>
    <div className="ccv2-field">
      <label className="ccv2-field-label" htmlFor={key1}>
        {name1}{required1 && <span className="ccv2-field-required">*</span>}
      </label>
      <Form.Control required={required1} type={type} id={key1} maxLength="250"
                    onChange={handleChange} value={formData[key1] || ''}/>
    </div>
    {name2 &&
      <div className="ccv2-field">
        <label className="ccv2-field-label" htmlFor={key2}>
          {name2}{required2 && <span className="ccv2-field-required">*</span>}
        </label>
        <Form.Control required={required2} type={type} id={key2} maxLength="250"
                      onChange={handleChange} value={formData[key2] || ''}/>
      </div>}
  </div>
});

const convertDefaultFieldNameToVariableName = (name) => {
  switch (name) {
    case 'FIRST_NAME':
      return 'firstName';
    case 'LAST_NAME':
      return 'lastName';
    case 'COMPANY_NAME':
      return 'companyName';
    case 'STREET_ADDRESS':
      return 'address';
    case 'APARTMENT_OFFICE_ETC':
      return 'additionalAddress';
    case 'CITY':
      return 'city';
    case 'FLIGHT_OR_TRAIN_NUMBER':
      return 'travelNumber';
    case 'EMAIL_ADDRESS':
      return 'email';
    case 'PHONE':
      return 'phone';
    case 'ZIP_CODE':
      return 'postalCode';
    default:
      return name;
  }
}

const generateId = (isDefaultField, id, name, column) => {
  return isDefaultField ? name : id + '-' + column;
}

export default FieldRow;